const FOOTER_LINKS = [
  { label: '核心功能', href: '#features' },
  { label: '省流指南', href: '#guide' },
  { label: '流量对比', href: '#compare' },
  { label: '常见问题', href: '#faq' },
];

export default function Footer() {
  return (
    <footer>
      <div id="download" className="relative overflow-hidden bg-primary-900 py-14 md:py-16">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-900 to-primary-800"></div>
        <div className="relative z-10 mx-auto max-w-7xl px-4 text-center md:px-6">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-background-50">
            <i className="ri-download-cloud-2-line"></i>
            免费省流，即刻开启
          </span>
          <h2 className="mx-auto mt-4 max-w-2xl font-heading text-2xl leading-snug text-background-50 md:text-4xl">
            开启数据节省，低流量浏览漫画更安心
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-background-100/85 md:text-base">
            省流画质、压缩图模式、流量监控与仅WiFi下载，为你的每一口流量负责。
          </p>
          <a
            href="#top"
            className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-400"
          >
            <i className="ri-download-2-line"></i>
            立即下载漫画人极速版
          </a>
        </div>
      </div>

      <div className="bg-primary-950 py-12">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            <div>
              <a href="#top" className="flex items-center gap-2.5">
                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500">
                  <i className="ri-ink-bottle-line text-lg text-background-50"></i>
                </span>
                <span className="font-heading text-lg text-background-50">漫画人极速版</span>
              </a>
              <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-100/70">
                专注为低流量用户打造的漫画阅读方案，省流画质、压缩图模式与流量监控，
                让每一话都看得畅快、用得安心。
              </p>
            </div>

            <div>
              <h3 className="text-sm font-bold text-background-50">站点导航</h3>
              <ul className="mt-4 space-y-2.5">
                {FOOTER_LINKS.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/70 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-bold text-background-50">联系我们</h3>
              <ul className="mt-4 space-y-2.5 text-sm text-background-100/70">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>kf@manhuajisu.example.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line"></i>
                  <span>客服时间 9:00 - 21:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 sm:flex-row">
            <p className="text-xs text-background-100/60">
              © {new Date().getFullYear()} 漫画人极速版 保留所有权利
            </p>
            <p className="text-xs text-background-100/60">
              省流画质 · 压缩图模式 · 流量监控 · 仅WiFi下载
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}